import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { PostData } from "../../services/postData";
import AvatarEditor from "react-avatar-editor";
import bsCustomFileInput from "bs-custom-file-input";
import MobileHeader from "../mobileHeader/mobileHeader";
import { Header } from "../../components";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import { DatePicker } from "react-rainbow-components";
import { confirmAlert } from "react-confirm-alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDay, faCalendarXmark } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/free-regular-svg-icons";
import "../../styles/custom.css";
import { faTrashRestoreAlt } from "@fortawesome/free-solid-svg-icons";
library.add(far);

class EditPool extends Component {
  constructor() {
    super();
    this.state = {
      navbar: {
        name: "Edit Pool",
        back: true,
        backLink: "/my-profile",
        menu: true,
        menuLink: "",
      },
      owner_id: "",
      pool_id: "",
      pool_title: "",
      pool_desc: "",
      pool_img: "",
      img_edited: false,
      date_format: "",
      due_date: "",
      limit_date: "",
      locale: { name: "en-US", label: "English (US)" },
      time_format: "",
      units: "",
      theme: "",
      color: "",
      canvas: "",
      allowZoomOut: false,
      position: { x: 0.5, y: 0.5 },
      scale: 1,
      rotate: 0,
      borderRadius: 100,
      preview: null,
      width: 400,
      height: 400,
      redirectToReferrer: false,
      message: "",
      loading: "",
      errors: {},
    };

    this.getPool = this.getPool.bind(this);
    this.editPool = this.editPool.bind(this);
    this.submitPool = this.submitPool.bind(this);
    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeDesc = this.onChangeDesc.bind(this);
    this.onChangeTimeFormat = this.onChangeTimeFormat.bind(this);
    this.onChangeDateFormat = this.onChangeDateFormat.bind(this);
    this.onChangeDueDate = this.onChangeDueDate.bind(this);
    this.onChangeUnits = this.onChangeUnits.bind(this);
    this.deletePool = this.deletePool.bind(this);
    this.deletePoolAction = this.deletePoolAction.bind(this);
  }

  componentDidMount() {
    if (!sessionStorage.getItem("userData")) {
      this.setState({ redirectToReferrer: true });
    } else {
      this.setPoolId();
    }
  }

  setPoolId() {
    this.setState({ pool_id: this.props.match.params.pool_id }, () => {
      this.getPool();
    });
  }

  getPool() {
    PostData("pool", this.state).then((result) => {
      let responseJson = result;
      if (responseJson.poolData) {
        // sessionStorage.setItem("poolData", JSON.stringify(responseJson));
        // this.setState({ redirectToReferrer: true });
        let due_date = new Date(responseJson.poolData.due_date + " 14:00 UTC");
        let limit_date = new Date(responseJson.poolData.limit_date + " 14:00 UTC");
        this.setState(
          {
            owner_id: responseJson.poolData.user_id,
            pool_title: responseJson.poolData.pool_title,
            pool_desc: responseJson.poolData.pool_desc,
            pool_img: `../../${responseJson.poolData.pool_img}`,
            date_format: responseJson.poolData.date_format,
            due_date: due_date,
            time_format: responseJson.poolData.time_format,
            units: responseJson.poolData.units,
            limit_date: limit_date,
            theme: responseJson.poolData.theme,
            color: responseJson.poolData.color,
          }
        );
        console.log(this.state);
      } else alert(result.error);
    });
  }

  editPool(e) {
    e.preventDefault();
    this.setState({ loading: true });
    setTimeout(
      function () {
        document.getElementById(
          "hidden-data"
        ).value = this.editor.getImageScaledToCanvas().toDataURL();
      }.bind(this),
      50
    );
    setTimeout(
      function () {
        let canvas = document.getElementById("hidden-data").value;
        this.setState({ canvas }, () => this.submitPool());
      }.bind(this),
      100
    );
  }

  submitPool() {
    let errors = {};
    let data = JSON.parse(sessionStorage.getItem("userData"));
    let postData = {
      user_id: data.userData.user_id,
      pool_id: this.state.pool_id,
      pool_title: this.state.pool_title,
      pool_desc: this.state.pool_desc,
      pool_img: this.state.canvas,
      img_edited: this.state.img_edited,
      date_format: this.state.date_format,
      due_date: this.state.due_date,
      time_format: this.state.time_format,
      units: this.state.units,
      limit_date: this.state.limit_date,
      theme: this.state.theme,
      color: this.state.color,
    };
    // if (this.validate()) {
    if (this.validate()) {
      PostData("editPool", postData).then((result) => {
        let responseJson = result;
        this.setState({ data: responseJson.newPoolData });
        if (responseJson.newPoolData) {
          console.log(JSON.stringify(responseJson));
          sessionStorage.setItem("newPoolData", JSON.stringify(responseJson));
          this.setState({ loading: false });
          // this.setState({ redirectToReferrer: true });
        } else {
          errors["editPool"] = result.error;
          document.getElementById("alert").classList.add("alert");
          this.setState({ loading: false });
          this.setState({
            errors: errors,
          });
        }
      });
    } else {
      this.setState({ loading: false });
    }
  }

  validate() {
    let errors = {};
    let isValid = true;

    if (this.state.limit_date === "") {
      isValid = false;
      errors["limit_date"] = "Limit date is required.";
      document.getElementById("limitDatePicker").classList.add("is-invalid");
    } else {
      document.getElementById("limitDatePicker").classList.remove("is-invalid");
    }

    if (this.state.due_date === "") {
      isValid = false;
      errors["due_date"] = "Due date is required.";
      document.getElementById("dueDatePicker").classList.add("is-invalid");
    } else {
      document.getElementById("dueDatePicker").classList.remove("is-invalid");
    }

    if (this.state.pool_desc === "") {
      isValid = false;
      errors["pool_desc"] = "Pool description is required.";
      document.getElementById("inputDesc").classList.add("is-invalid");
      document.getElementById("inputDescContainer").scrollIntoView({
        block: "end",
        behavior: "smooth",
      });
    } else {
      document.getElementById("inputDesc").classList.remove("is-invalid");
    }

    if (this.state.pool_title === "") {
      isValid = false;
      errors["pool_title"] = "Pool title is required.";
      document.getElementById("inputTitle").classList.add("is-invalid");
      document.getElementById("inputTitleContainer").scrollIntoView({
        block: "end",
        behavior: "smooth",
      });
    } else {
      document.getElementById("inputTitle").classList.remove("is-invalid");
    }

    this.setState({
      errors: errors,
    });

    console.log(this.state);

    return isValid;
  }

  handleNewImage = (e) => {
    this.setState({
      pool_img: e.target.files[0],
      scale: 1.125,
      img_edited: true
    });
    document.getElementById("zoom-control").value = 1.125;
    document.getElementById("fileInputLabel").innerText = e.target.files[0].name;
  };

  handleScale = (e) => {
    const scale = parseFloat(e.target.value);
    this.setState({ scale });
    this.setState({ img_edited: true });
  };

  handlePositionChange = (position) => {
    this.setState({ position });
    this.setState({ img_edited: true });
  };

  onChangeTimeFormat(value) {
    this.setState({ time_format: value });
  }

  onChangeDateFormat(value) {
    this.setState({ date_format: value });
  }

  onChangeUnits(value) {
    this.setState({ units: value });
    console.log(this.state);
  }

  onChangeDueDate(value) {
    this.setState({ due_date: value }, () => {
      let error = "";

      if (this.state.due_date === "") {
        error = "Due date is required.";
        document.getElementById("dueDatePicker").classList.add("is-invalid");
      } else {
        document.getElementById("dueDatePicker").classList.remove("is-invalid");
      }

      this.setState((prevState) => {
        let errors = Object.assign({}, prevState.errors);
        errors.due_date = error;
        return { errors };
      });
    });
  }

  onChangeLimitDate(value) {
    this.setState({ limit_date: value }, () => {
      let error = "";

      if (this.state.limit_date === "") {
        error = "Due date is required.";
        document.getElementById("limitDatePicker").classList.add("is-invalid");
      } else {
        document.getElementById("limitDatePicker").classList.remove("is-invalid");
      }

      this.setState((prevState) => {
        let errors = Object.assign({}, prevState.errors);
        errors.limit_date = error;
        return { errors };
      });
    });
  }

  onChangeTitle(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      let error = "";

      if (this.state.pool_title === "") {
        error = "Pool title is required.";
        document.getElementById("inputTitle").classList.add("is-invalid");
      } else {
        document.getElementById("inputTitle").classList.remove("is-invalid");
      }

      this.setState((prevState) => {
        let errors = Object.assign({}, prevState.errors);
        errors.pool_title = error;
        return { errors };
      });
    });
  }

  onChangeDesc(e) {
    let countDesc = document.getElementById("countDesc");
    countDesc.innerHTML = e.target.value.length + " / 250";

    this.setState({ [e.target.name]: e.target.value }, () => {
      let error = "";

      if (this.state.pool_desc === "") {
        error = "Pool description is required.";
        document.getElementById("inputDesc").classList.add("is-invalid");
      } else {
        document.getElementById("inputDesc").classList.remove("is-invalid");
      }

      this.setState((prevState) => {
        let errors = Object.assign({}, prevState.errors);
        errors.pool_desc = error;
        return { errors };
      });
    });
  }

  setEditorRef = (editor) => (this.editor = editor);

  deletePool() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h2 className="mb-4">Are you sure?</h2>
            <p>Do you really want to delete this pool?</p>
            <p>This will also delete all the betz in this pool and is <strong>not&nbsp;reversable.</strong></p>
            <button
              className="btn btn-primary btn-sm px-4"
              onClick={() => {
                this.deletePoolAction(this.state.pool_id);
                onClose();
              }}
            >
              Yes, Delete it!
            </button>
            <button
              className="btn btn-outline-primary btn-sm ml-4 px-4"
              onClick={onClose}
            >
              No
            </button>
          </div>
        );
      },
      //   title: "Delete Pool",
      //   message:
      //     "Are you sure you want to delete this pool? This will also delete all betz in this pool.",
      //   buttons: [
      //     {
      //       label: "Yes",
      //       onClick: () => this.deletePoolAction(this.state.pool_id, updateIndex),
      //     },
      //     {
      //       label: "No",
      //       onClick: () => console.log("no"),
      //     },
      //   ],
    });
  }

  deletePoolAction(pool_id) {
    //let pool_id = document.getElementById("del").getAttribute("pools");

    let user = JSON.parse(sessionStorage.getItem("userData"));

    let postData = { user_id: user.userData.user_id, pool_id: pool_id };
    if (postData) {
      PostData("poolDelete", postData).then((result) => {
        if (result.success) {
          alert(result.success);
          this.setState({ redirectToReferrer: true });
        } else alert(result.error);
      });
    }
  }

  render() {
    if (this.state.redirectToReferrer) {
      return <Redirect to={"/my-profile"} />;
    }
    if (sessionStorage.getItem("newPoolData")) {
      return <Redirect to={`/pool/${this.state.pool_id}`} />;
    }
    return (
      <>
      <Header theme="color"/>
      <MobileHeader
        name={this.state.navbar.name}
        back={this.state.navbar.back}
        backLink={`/pool/${this.state.pool_id}`}
        menu={this.state.navbar.menu}
        menuLink={this.state.navbar.menuLink}
        theme="white"
      />
      <h3 className="large-only text-center d-none d-lg-block my-4">{this.state.navbar.name}</h3>
      <div className="boxed" id="Body">
        <div className="backdrop box-shadow mb-4">
          <div className="medium-12 columns">
            <div className="form-label-group signup-label" id="inputTitleContainer">
              <input
                type="text"
                name="pool_title"
                id="inputTitle"
                placeholder="Pool Title"
                required
                defaultValue={this.state.pool_title}
                onChange={this.onChangeTitle}
              />
              <label htmlFor="inputTitle">Pool Title</label>
              <div className="invalid-feedback">
                {this.state.errors.pool_title}
              </div>
            </div>
            <div className="form-label-group signup-label" id="inputDescContainer" >
              <textarea
                name="pool_desc"
                id="inputDesc"
                placeholder="Pool Description"
                rows="3"
                required
                defaultValue={this.state.pool_desc}
                onChange={this.onChangeDesc}
              />
              <span className="badge badge-secondary" id="countDesc">
                0 / 250
              </span>
              <label htmlFor="inputDesc">Pool Description</label>
              <div className="invalid-feedback">
                {this.state.errors.pool_desc}
              </div>
            </div>
            Pool Image
            <br />
            <textarea id="hidden-data" />
            <div className="text-center">
              <AvatarEditor
                ref={this.setEditorRef}
                scale={parseFloat(this.state.scale)}
                width={this.state.width}
                height={this.state.height}
                position={this.state.position}
                onPositionChange={this.handlePositionChange}
                rotate={parseFloat(this.state.rotate)}
                borderRadius={
                  this.state.width / (100 / this.state.borderRadius)
                }
                color={[255, 255, 255, 0.6]}
                image={
                  this.state.pool_img
                    ? this.state.pool_img
                    : "/assets/pools/placeholder.jpg"
                }
                className="editor-canvas"
              />
            </div>
            <div className="form-group">
              <label htmlFor="formControlRange">Zoom</label>
              <input
                type="range"
                className="form-control-range"
                id="zoom-control"
                name="scale"
                step="0.01"
                min={this.state.allowZoomOut ? "0.1" : "1"}
                max="2"
                defaultValue={parseFloat(this.state.scale)}
                onChange={this.handleScale}
              />
            </div>
            <br />
            <div className="custom-file">
              <input
                type="file"
                id="fileInput"
                className="custom-file-input"
                accept="image/*"
                onChange={this.handleNewImage}
              />
              <label
                className="custom-file-label"
                htmlFor="fileInput"
                id="fileInputLabel"
              >
                Add a New Image
              </label>
            </div>
            <label htmlFor="date_format">Date Format</label>
            <ToggleButtonGroup
              type="radio"
              name="date_format"
              value={this.state.date_format}
              onChange={this.onChangeDateFormat}
            >
              <ToggleButton
                variant="outline-secondary"
                size="lg"
                value={"mm-dd-yyyy"}
              >
                MM / DD / YYYY
              </ToggleButton>
              <ToggleButton
                variant="outline-secondary"
                size="lg"
                value={"dd-mm-yyyy"}
              >
                DD / MM / YYYY
              </ToggleButton>
              <ToggleButton
                variant="outline-secondary"
                size="lg"
                value={"yyyy-mm-dd"}
              >
                YYYY / MM / DD
              </ToggleButton>
            </ToggleButtonGroup>
            <br />
            <br />
            <label htmlFor="due_date">Predicted Due Date</label>
            <div className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto">
              <DatePicker
                placeholder="Select a Due Date"
                id="dueDatePicker"
                value={this.state.due_date}
                minDate={new Date()}
                onChange={(value) => this.onChangeDueDate(value)}
                // label="Due Date"
                valueAlignment="center"
                formatStyle="medium"
                locale={this.state.locale.name}
                icon={<FontAwesomeIcon icon={faCalendarDay} size="lg" />}
                required={true}
              />
              <div className="invalid-feedback">
                {this.state.errors.due_date}
              </div>
            </div>
            <br />
            <label htmlFor="time_format">Time Format</label>
            <ToggleButtonGroup
              type="radio"
              name="time_format"
              value={this.state.time_format}
              onChange={this.onChangeTimeFormat}
            >
              <ToggleButton variant="outline-secondary" size="lg" value={"12h"}>
                12-hour (2 PM)
              </ToggleButton>
              <ToggleButton variant="outline-secondary" size="lg" value={"24h"}>
                24-hour (14:00)
              </ToggleButton>
            </ToggleButtonGroup>
            <br />
            <br />
            {/* <label htmlFor="units">Units of Measurement</label>
            <ToggleButtonGroup
              type="radio"
              name="units"
              value={this.state.units}
              onChange={this.onChangeUnits}
            >
              <ToggleButton
                variant="outline-secondary"
                size="lg"
                value={"imperial"}
              >
                Imperial
              </ToggleButton>
              <ToggleButton
                variant="outline-secondary"
                size="lg"
                value={"both"}
              >
                Both
              </ToggleButton>
              <ToggleButton
                variant="outline-secondary"
                size="lg"
                value={"metric"}
              >
                Metric
              </ToggleButton>
            </ToggleButtonGroup>
            <br /> */}
            <label htmlFor="limit_date">Accept Betz Until</label>
            <div className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto">
              <DatePicker
                placeholder="Select a Limit Date"
                id="limitDatePicker"
                value={this.state.limit_date}
                minDate={new Date()}
                maxDate={this.state.due_date}
                onChange={(value) => this.onChangeLimitDate(value)}
                // label="Due Date"
                valueAlignment="center"
                formatStyle="medium"
                locale={this.state.locale.name}
                icon={<FontAwesomeIcon icon={faCalendarXmark} size="lg" />}
                required={true}
              />
              <div className="invalid-feedback">
                {this.state.errors.limit_date}
              </div>
            </div>
            <br />
            <div className="alert-warning" role="alert" id="alert">
              {this.state.errors.editPool}
            </div>
            <div className="cancel-submit mt-4">
              <a
                href={`/pool/${this.state.pool_id}`}
                className="btn btn-outline-primary btn-lg px-4 mr-3"
              >
                Cancel
              </a>
              <button
                type="submit"
                value="Post"
                className="btn btn-primary btn-lg flex-grow-1"
                onClick={this.editPool}
              >
                <span
                  className="spinner-border spinner-border-sm"
                  style={{
                    display: this.state.loading ? "inline-block" : "none",
                  }}
                  role="status"
                  aria-hidden="true"
                ></span>
                Save
              </button>
            </div>
          </div>
        </div>
        <button
          onClick={this.deletePool}
          className="btn btn-link btn-link-white btn-sm mb-3"
        >
          <FontAwesomeIcon icon={["far", "trash-alt"]} size="sm" /> Delete this
          pool
        </button>
      </div>
      </>
    );
  }
}
export default EditPool;
